import { Menu } from '@pocketlaw/tetris';
export function MenuMultiSelectItem(props) {
    const { disabled, selected = false, onClick, children, loading } = props;
    return (<Menu.Item selected={selected} disabled={disabled} loading={loading} onClick={onClick}>
      {children}
    </Menu.Item>);
}
